import { useState } from "react";
import { BiSolidChevronDown, BiSolidChevronRight } from "react-icons/bi";
import "./PlayerGroup.css"
import PlayerPanel from "../PlayerPanel/PlayerPanel";

const PlayerGroup = ({playerGroup, isPlayerSelected, ChangePlayerSelection}) => {

    const [hidden, setHidden] = useState(false)

    if(playerGroup.players.length == 0)
        return <></>;

    return (
        <>
            <div onClick={() => setHidden(!hidden)} className="playerGroup">
                <div className="groupLine mr-2" />
                    
                <div className="text-center mr-1">
                    {playerGroup.name}
                </div>
                { hidden &&
                    <BiSolidChevronRight /> 
                }
                { !hidden &&
                    <BiSolidChevronDown /> 
                }  
                <div className="groupLine ml-2" />
            </div>
            { !hidden &&
                <div>
                    {playerGroup.players.map(player => 
                        <PlayerPanel player={player} isPlayerSelected={isPlayerSelected} ChangePlayerSelection={ChangePlayerSelection}/>
                    )}
                </div>
            }


        </>
    )
}

export default PlayerGroup;